export default function customLoader({ src, width, quality }) {
  return `${src}?width=${width}&quality=${quality || 75}`;
}
